/**
 * This method to check value of station id is valid or not
 * @param value  - any type of value
 * @example - 
 * ```
 * isValidStationId(data);
 * ```
 * 
 * @returns  - true/false
 */
export const isValidPhoneNumber = (value: string) => {
  const filter = /^(\+?)([0-9#\\*])+$/;
  if (filter.test(value) && value.length <= 30) {
    return true;
  }
  return false;
}


/**
* This method to check value of station id is valid or not
* @param value  - any type of value
* @example - 
* ```
* isValidStationId(data);
* ```
* 
* @returns  - true/false
*/
export const isValidStationId = (value: string)=> {
  const filter = /^[0-9]+$/;
  return filter.test(value);
}

/**
* This method accepts minutes and return hours and min format
* @param value  - any type of number
* @example - 
* ```
* converMinutestoHours(min);
* ```
* 
* @returns  - 1 hr 30 min
*/
export const convertMinutestoHours =(seconds:number)=> {
  const days = Math.floor(seconds / (3600*24));
  seconds  -= days*3600*24;
  const hrs   = Math.floor(seconds / 3600);
  seconds  -= hrs*3600;
  const mnts = Math.floor(seconds / 60);
  seconds  -= mnts*60;
  if(days){
    return days+'d '+hrs+'h '+mnts+'m '+seconds+'s';
  }else if(hrs){
    return hrs+'h '+mnts+'m '+seconds+'s'
  }else if(mnts){
    return mnts +'m '+seconds+'s';
  }else{
    return seconds +'s';
  }
}